<template>
  <div>
    <v-data-table
      style="background: #a9a9a93d"
      fixed-header
      :height="tableHeight"
      :items="data"
      :options.sync="options"
      :headers="headerList"
      :loading="tableLoading"
      :server-items-length="getPaginator.total"
      :footer-props="footerProps"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer />
          <v-dialog
            v-model="officeDialog"
            max-width="540px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                Добавить
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      :sm="6"
                      class="py-0 my-0"
                    >
                      <v-text-field
                        v-model="userForm.email"
                        label="Почта"
                        :rules="emailRules"
                        :error-messages="formErrors('email')"
                        required
                        @change="$v.userForm.email.$touch()"
                        @blur="$v.userForm.email.$touch()"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="12"
                      :md="6"
                      class="py-0 my-0"
                    >
                      <v-text-field
                        v-model="userForm.firstName"
                        label="Имя"
                        :error-messages="formErrors('firstName')"
                        required
                        @change="$v.userForm.firstName.$touch()"
                        @blur="$v.userForm.firstName.$touch()"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="6"
                      class="py-0 my-0"
                    >
                      <v-text-field
                        v-model="userForm.lastName"
                        label="Фамилия"
                        :error-messages="formErrors('lastName')"
                        required
                        @change="$v.userForm.lastName.$touch()"
                        @blur="$v.userForm.lastName.$touch()"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="12"
                      :md="6"
                      class="py-0 my-0"
                    >
                      <v-select
                        v-model="userForm.role"
                        :items="roleList"
                        label="Роль"
                        :item-text="'title'"
                        :item-value="'id'"
                        return-object
                        :error-messages="formErrors('role')"
                        required
                        @change="onRoleChange"
                        @blur="$v.userForm.role.$touch()"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="6"
                      class="py-0 my-0"
                    >
                      <v-text-field
                        v-model="userForm.middleName"
                        label="Отчество"
                        required
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="12"
                      :md="6"
                      class="py-0 my-0"
                    >
                      <v-text-field
                        v-model="userForm.telephone"
                        label="Телефон"
                        required
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="6"
                      class="py-0 my-0"
                    >
                      <v-text-field
                        v-model="userForm.profession"
                        label="Должность"
                        required
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="12"
                      class="py-0 my-0"
                    >
                      <v-autocomplete
                        v-if="!isRoot"
                        v-model="userForm.officeList"
                        :items="getOfficeList"
                        :multiple="isAdmin"
                        return-object
                        item-value="id"
                        :disabled="!userForm.role"
                        item-text="title"
                        label="объекты"
                        outlined
                        chips
                        :hint="'Выберите роль'"
                        :persistent-hint="!userForm.role"
                        small-chips
                        :search-input.sync="officeSearchQuery"
                        append-outer-icon="fa-search"
                        @click:append-outer="onSearchOffice"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="removeOffice(data.item)"
                          >
                            {{ data.item.title }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                      <!--                      <v-text-field-->
                      <!--                        v-model="searchOffice"-->
                      <!--                        :label="'Поиск объектов'"-->
                      <!--                        single-line-->
                      <!--                        append-outer-icon="fa-search"-->
                      <!--                        clearable-->
                      <!--                        @input="onQuerySearchChange"-->
                      <!--                        @click:append-outer="onSearchOffice"-->
                      <!--                      />-->
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Отменить
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  сохранить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogDelete"
            max-width="500px"
          >
            <v-card>
              <v-card-title class="headline">
                Удалить этот пользователь?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  Нет
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  Да
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.isActive="{ item }">
        <v-btn
          icon
          small
          :color="item.isActive ? 'success' : 'error'"
        >
          <v-icon small>
            {{ item.isActive ? 'fa-check' : 'fa-close' }}
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:item.registrationConfirmLink="{ item }">
        <div
          v-if="item.registrationConfirmLink"
          style="min-width: 160px"
        >
          <span style="display: block">
            {{ `От ${formatDate(item.registrationConfirmLink.createdAt)} ` }}
          </span>
          {{ `${item.registrationConfirmLink.status === 'done' ? 'Просмотрено': 'Не просмотрено'} ` }}
          <v-btn
            small
            icon
            color="info"
            @click="copyLink(item.registrationConfirmLink)"
          >
            <v-icon>
              fa-copy
            </v-icon>
          </v-btn>
          <v-icon
            color="success"
            small
          >
            mdi-check-all
          </v-icon>
        </div>
        <span v-else />
      </template>
      <template v-slot:item.passwordResetLink="{ item }">
        <div
          v-if="item.passwordResetLink"
          style="min-width: 140px"
        >
          <span style="display: block">
            {{ `От ${formatDate(item.passwordResetLink.createdAt)} ` }}
          </span>
          <span>
            {{ `${item.passwordResetLink.status === 'done' ? 'Просмотрено': 'Не просмотрено'} ` }}
          </span>
          <v-btn
            small
            color="info"
            icon
            @click="copyLink(item.passwordResetLink)"
          >
            <v-icon>
              fa-copy
            </v-icon>
          </v-btn>
        </div>
        <span v-else />
      </template>
      <template v-slot:item.roleList="{ item }">
        <v-btn
          v-for="role in getRoleTitle(item.roleList)"
          :key="role"
          x-small
          outlined
          color="success"
          block
          class="my-0 py-0 mx align-start mb-1"
          style="text-align: left"
        >
          <span
            class="btn-inside"
          >{{ role }}</span>
        </v-btn>
      </template>
      <template
        v-slot:item.officeList="{ item }"
      >
        <div
          v-if="item.officeList.length"
          class="my-0 py-0"
        >
          <v-btn
            v-for="office in item.officeList"
            :key="office.id"
            x-small
            outlined
            color="success"
            block
            class="my-0 py-0 mx align-start mb-1"
            style="text-align: left"
          >
            <span
              class="btn-inside"
            >{{ office.title }}</span>
          </v-btn>
        </div>
        <div
          v-else-if="item.office && item.office.id"
          class="my-0 py-0"
        >
          <v-btn
            x-small
            outlined
            color="success"
            block
            class="my-0 py-0 mx align-start mb-1"
            style="text-align: left"
          >
            <span
              class="btn-inside"
            >{{ item.office.title }}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:item.options="{ item }">
        <div style="display: flex; flex-direction: row; justify-content: space-between">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import ListMixin from '@/mixins/list-mixin.vue'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import { formatDate } from '@/utils/date-util'
import { ROLE_ORGANIZATION_ADMIN, ROLE_ORGANIZATION_MANAGER, ROLE_ORGANIZATION_ROOT } from '@/utils/client-roles-util'

export default {
  name: 'OrganizationUserTabComponent',
  components: { },
  mixins: [ListMixin, validationMixin],
  validations: {
    userForm: {
      email: { required, email },
      firstName: { required },
      lastName: { required },
      role: { required },
    }
  },
  props: {
    tableLoading: {
      type: Boolean
    },
    data: {
      type: Array
    },
    officeList: {
      type: Array
    },
    userListOptions: {
      type: Object
    },
  },
  data: () => ({
    canView: false,
    searchOffice: null,
    options: {},
    viewLoading: false,
    roleList: [
      { 'id': ROLE_ORGANIZATION_MANAGER, 'title': 'Менеджер объекта' },
      { 'id': ROLE_ORGANIZATION_ADMIN, 'title': 'Администратор объектов' },
      // { 'id': ROLE_ORGANIZATION_ROOT, 'title': 'Главный админ' },
    ],
    headerList: [
      {
        text: 'ФИО',
        align: 'left',
        sortable: false,
        value: 'fullName',
      },
      {
        text: 'Роль',
        align: 'left',
        sortable: false,
        value: 'roleList',
      },
      { text: 'Телефон', value: 'telephone', sortable: false },
      { text: 'Электронная почта', value: 'email', sortable: false },
      { text: 'Должность', value: 'profession', sortable: false },
      { text: 'Активирован', value: 'isActive', sortable: false },
      { text: 'Объекты', value: 'officeList', sortable: false },
      { text: 'Подт. Регистрации', value: 'registrationConfirmLink', sortable: false },
      { text: 'Восстановление пароля. пароля', value: 'passwordResetLink', sortable: false },
      { text: '', value: 'options' },
    ],
    officeDialog: false,
    dialogDelete: false,
    officeSearchQuery: '',
    userForm: {
      id: null,
      email: '',
      firstName: '',
      lastName: '',
      middleName: '',
      profession: '',
      telephone: '',
      role: '',
      officeList: [],
    },
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    defaultUser: {
      id: null,
      email: '',
      firstName: '',
      lastName: '',
      middleName: '',
      profession: '',
      role: '',
      telephone: '',
      officeList: [],
    },
    weatherConditionList: []
  }),
  computed: {
    isAdmin () {
      return this.userForm.role && [
        ROLE_ORGANIZATION_ADMIN
      ].includes(
        this.userForm.role.id
      )
    },
    isRoot () {
      return this.userForm.role && [
        ROLE_ORGANIZATION_ROOT
      ].includes(
        this.userForm.role.id
      )
    },
    getPaginator () {
      return this.$store.getters['client/getPaginator']
    },
    getOfficeList () {
      return this.$store.getters['office/getStoreList']
    },

    formTitle () {
      return `${!this.userForm.id ? 'Добавление' : 'редактирование'} пользователя`
    },
  },
  watch: {
    officeDialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    options: {
      handler (val) {
        this.$emit('onOfficeOptionChange', val)
      },
      deep: true,
    },
  },
  created () {
    this.options = { ...this.userListOptions }

    this.onQuerySearchChange()
    this.requestWeatherConditionList()
  },
  methods: {
    onQuerySearchChange () {
      this.$store.commit(
        'office/GET_MODEL_LIST_COMPLETED',
        { modelList: [], total: 0 },
      )
    },
    async onSearchOffice () {
      await this.requestOfficeList()
    },
    async requestOfficeList (page = 1, size = 250) {
      const params = { 'organization[id]': this.$route.params.id, 'page[number]': page, 'page[size]': size }
      if (this.officeSearchQuery) {
        params.searchQuery = this.officeSearchQuery
        await this.$store.dispatch(
          'office/getModelList',
          { params }

        )
      }
      this.loading = false
    },
    formatDate (date, format = 'DD MMMM HH:mm') {
      return formatDate(date, format = 'DD MMMM HH:mm')
    },
    requestWeatherConditionList () {
      this.$store.dispatch('organization/getWeatherConditionList')
        .then((response) => {
          const list = response.data

          if (list && list.length) {
            const mapper = {
              'cold': 'Холодный',
              'normal': 'Нормальный',
            }

            this.weatherConditionList = list.map((item) => ({ ...item, title: mapper[item.title] || item.title }))
          }
        })
    },
    editItem (item) {
      let role = null
      let officeList = []
      if (item.roleList) {
        const userRole = item.roleList[0]
        if (userRole === 'ROLE_ORGANIZATION_MANAGER') {
          officeList.push(item.office)
        } else {
          officeList = item.officeList.filter((ofc) => ofc && ofc.id).map(({ id }) => ({ id }))
        }
        role = this.roleList.find((role) => role.id === userRole)
      }
      this.userForm = {
        id: item.id,
        firstName: item.firstName,
        lastName: item.lastName,
        middleName: item.middleName,
        profession: item.profession,
        telephone: item.telephone,
        role,
        email: item.email,
        officeList,
      }

      this.officeDialog = true
    },

    deleteItem (item) {
      // this.editedIndex = this.desserts.indexOf(item)
      // this.userForm = Object.assign({}, item)
      this.dialogDelete = true
    },

    copyLink (item) {
      const el = document.createElement('textarea')
      el.value = item.url || ''
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    },

    deleteItemConfirm () {
      this.desserts.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.officeDialog = false
      this.$nextTick(() => {
        this.userForm = Object.assign({}, this.defaultUser)
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.userForm = Object.assign({}, this.defaultUser)
        this.editedIndex = -1
      })
    },

    async save () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return false
      }

      let officeList = []

      if (Array.isArray(this.userForm.officeList)) {
        officeList = this.userForm.officeList.filter((ofc) => ofc && ofc.id).map(({ id }) => ({ id }))
      } else if (this.userForm.officeList && this.userForm.officeList.id) {
        officeList = [{ id: this.userForm.officeList.id }]
      }

      const model = {
        ...this.userForm,
        'officeList': officeList,
        'organization': { 'id': this.$route.params.id },
        'role': this.userForm.role.id,
      }
      this.showPageLoader()

      const method = model.id ? 'editClient' : 'inviteClient'

      this.$store.dispatch(
        `organization/${method}`,
        model
      ).then((response) => {
        this.$emit('reloadUserList', false)
        this.close()
        this.hidePageLoader()
      }).catch(() => {
        this.hidePageLoader()
      })
    },
    formErrors (field) {
      const errors = []
      const taskField = this.$v.userForm[field]
      if (!taskField.$dirty) return errors
      !taskField.required && errors.push('поле обязательно для заполнения.')
      return errors
    },
    onRoleChange () {
      this.$v.userForm.role.$touch()
      this.userForm.officeList = []
    },
    removeOffice (office) {
      this.userForm.officeList = this.userForm.officeList.filter((item) => item.id !== office.id)
    },
    getRoleTitle (roleList) {
      const mapped = []
      for (const role of roleList) {
        const filtered = this.roleList.filter((item) => {
          return item.id === role
        })
        if (filtered.length) {
          mapped.push(filtered[0].title)
        } else {
          mapped.push(role)
        }
      }


      return mapped
    },
  }
}
</script>
<style lang="scss" scoped>
.item-label{
  text-align: right;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */
  color: #000000;
}
.item-value{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */

  text-align: left;
  color: #000000;
  opacity: 0.5;
}
.btn-inside{
  color: black; display: block; margin: 0; padding: 0; text-align: left; width: 100%; text-transform: none;
}
</style>
